import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { ELEMENTS_FEATURE_KEY } from './keys';
import { elementsReducer } from './reducers/elements.reducer';
import { ElementsEffects } from './effects/elements.effects';
import { ElementsElementBridge } from './bridges/elements_element.bridge';

export function provideElementsStore(): EnvironmentProviders[] {
    return [provideState(ELEMENTS_FEATURE_KEY, elementsReducer), provideEffects(ElementsEffects, ElementsElementBridge)];
}
